import clsx from "clsx";
import { useIntl } from "react-intl";

import { CollapsibleCard } from "@/components/CollapsibleCard/CollapsibleCard";
import type { FindPackageByIdCountry } from "@/types/codegen";

type Props = {
  countries: FindPackageByIdCountry[];
};

export function VisaPermissionsCard({ countries }: Props) {
  const intl = useIntl();

  return (
    <CollapsibleCard
      title={intl.formatMessage({
        defaultMessage: "Visa permissions",
        description: "trips.visaPermissions.title",
      })}
      subtitle={intl.formatMessage({
        defaultMessage: "Visa requirements and assistance details",
        description: "trips.visaPermissions.subtitle",
      })}
      collapsible={false}
    >
      <ul className="space-y-2">
        {countries?.map(({ id, name, visaType }) => {
          const getVisaTranslation = () => {
            switch (visaType) {
              case "E_VISA":
                return intl.formatMessage({
                  defaultMessage: "e-Visa",
                  description: "trips.visaTypes.eVisa",
                });
              case "VISA_ON_ARRIVAL":
                return intl.formatMessage({
                  defaultMessage: "Visa on arrival",
                  description: "trips.visaTypes.visaOnArrival",
                });
              case "VISA_FREE":
                return intl.formatMessage({
                  defaultMessage: "Visa free",
                  description: "trips.visaTypes.visaFree",
                });
              case "VISA_REQUIRED":
                return intl.formatMessage({
                  defaultMessage: "Visa required",
                  description: "trips.visaTypes.visaRequired",
                });
              default:
                return visaType; // Fallback to raw value if no translation is found
            }
          };

          return (
            <li
              key={id}
              className={clsx(
                "flex items-center justify-between rounded-xl p-3 text-sm font-medium text-text-primary",
                visaType === "VISA_FREE"
                  ? "bg-surface-accent-softer"
                  : visaType === "VISA_REQUIRED"
                    ? "bg-semantic-error-pressed-soft"
                    : "bg-semantic-warning-soft",
              )}
            >
              <span>{name}</span>
              <span>{getVisaTranslation()}</span>
            </li>
          );
        })}
      </ul>
    </CollapsibleCard>
  );
}
